<template>
	<div>
		<!--    搜索部分-->
		<el-form :inline="true" :model="enquiryForm" class="demo-form-inline" label-width="80px">
			<el-form-item label="机构">
				<el-input placeholder="请选择" v-model="enquiryForm.organiza" size="medium" :disabled="true">
					<el-button slot="append" @click="mechanismSearch(1)">选择</el-button>
				</el-input>
			</el-form-item>
			<el-form-item label="运营中心">
				<el-input placeholder="请选择" v-model="enquiryForm.opera_center" size="medium" :disabled="true">
					<el-button slot="append" @click="mechanismSearch(2)">选择</el-button>
				</el-input>
			</el-form-item>
			<el-form-item label="代理商">
				<el-input placeholder="请选择" v-model="enquiryForm.agent" size="medium" :disabled="true">
					<el-button slot="append" @click="mechanismSearch(3)">选择</el-button>
				</el-input>
			</el-form-item>
			<el-form-item label="顶级代理商">
				<el-input placeholder="请选择" v-model="enquiryForm.top_agent" size="medium" :disabled="true">
					<el-button slot="append" @click="mechanismSearch(4)">选择</el-button>
				</el-input>
			</el-form-item>


			<el-form-item label="商户号">
				<el-input size="medium" clearable v-model="enquiryForm.merchant_code" placeholder="请输入商户号"></el-input>
			</el-form-item>
			<el-form-item label="商户名称">
				<el-input size="medium" clearable v-model="enquiryForm.merchant_name" placeholder="请输入商户名称"></el-input>
			</el-form-item>
			<el-form-item label="手机号码">
				<el-input size="medium" clearable v-model="enquiryForm.mobile_phone" placeholder="请输入手机号码"></el-input>
			</el-form-item>

			<el-form-item label="商户状态">
				<el-select v-model="enquiryForm.merchant_status" medium clearable placeholder="请选择商户状态">
					<el-option label="未绑定" value="10"></el-option>
					<el-option label="已解绑" value="20"></el-option>
					<el-option label="调拨中" value="30"></el-option>
					<el-option label="已绑定" value="40"></el-option>
					<el-option label="已激活" value="50"></el-option>
					<el-option label="已达标" value="60"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="终端类型">
				<el-select v-model="enquiryForm.pos_type" medium clearable placeholder="请选择终端类型">
					<el-option label="杉峰Pro平台" value="10"></el-option>
					<el-option label="河马付" value="20"></el-option>
					<el-option label="手机POS" value="30"></el-option>
				</el-select>
			</el-form-item>
      <el-form-item label="河马付状态">
        <el-select v-model="enquiryForm.hmf_merchant_status" medium clearable placeholder="请选择河马付商户状态">
          <el-option label="创建" value="0"></el-option>
          <el-option label="启用" value="1"></el-option>
          <el-option label="业务待审核" value="2"></el-option>
          <el-option label="待审核" value="3"></el-option>
          <el-option label="初审通过" value="4"></el-option>
          <el-option label="审核未通过" value="5"></el-option>
          <el-option label="停用" value="6"></el-option>
          <el-option label="被风控" value="7"></el-option>
        </el-select>
      </el-form-item>

			<el-form-item label="更新时间" style="width: 590px">
				<el-date-picker v-model="enquiryForm.modify_time" type="datetimerange" range-separator="至"
					start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
					@change="pickerChange2">
				</el-date-picker>
			</el-form-item>
<!--			<el-form-item label="注册日期" style="width: 590px">-->
<!--				<el-date-picker v-model="enquiryForm.create_time" type="datetimerange" range-separator="至"-->
<!--					start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"-->
<!--					@change="pickerChange">-->
<!--				</el-date-picker>-->
<!--			</el-form-item>-->

		</el-form>
    <div style="margin-bottom: 10px">
      <el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch(enquiryForm)">查询</el-button>
      <el-button size="medium"  style="font-size: 12px;" @click="Reset(enquiryForm)">重置</el-button>
      <el-button size="medium" type="warning" style="font-size: 12px;" @click="exportData">导出</el-button>
      <el-button size="medium"  type="danger" style="font-size: 12px;" @click="printEvent()"> 打印</el-button>
    </div>
<!-- //打印 -->
			<prints ref="prints" :tableData="tableData" :tableTh="tableTh" :tableTd="tableTd" v-show="false"></prints>
		<!--    表格部分-->
		<el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}"
			v-loading="loading" border id="tableDataId" size="mini">
			<el-table-column header-align="center" align="center" prop="id" label="ID" sortable>
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="user_name" label="盟友名称">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="mobile_phone" label="盟友手机号">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="merchant_from" label="商户来源">
<!--				<template slot-scope="scope">-->
<!--					<p>{{ scope.row.merchant_from.text}}</p>-->
<!--				</template>-->

			</el-table-column>
      <el-table-column header-align="center" align="center" prop="platform_merchant_code" label="平台商户号">
      </el-table-column>
			<el-table-column header-align="center" align="center" prop="merchant_code" label="商户编号">
			</el-table-column>
<!--			<el-table-column header-align="center" align="center" prop="device_code" label="终端号">-->
<!--			</el-table-column>-->
			<el-table-column header-align="center" align="center" prop="merchant_name" label="商户名称">
			</el-table-column>
      <el-table-column header-align="center" align="center" prop="merchant_status" label="商户状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.merchant_status.value == '10'" type="warning" disable-transitions>
            {{scope.row.merchant_status.text}}</el-tag>
          <el-tag v-if="scope.row.merchant_status.value == '20'" type="warning" disable-transitions>
            {{scope.row.merchant_status.text}}</el-tag>
          <el-tag v-if="scope.row.merchant_status.value == '30'" type="danger" disable-transitions>
            {{scope.row.merchant_status.text}}</el-tag>
          <el-tag v-if="scope.row.merchant_status.value == '40'" type="success" disable-transitions>
            {{scope.row.merchant_status.text}}</el-tag>
          <el-tag v-if="scope.row.merchant_status.value == '50'" type="success" disable-transitions>
            {{scope.row.merchant_status.text}}</el-tag>
          <el-tag v-if="scope.row.merchant_status.value == '60'" type="success" disable-transitions>
            {{scope.row.merchant_status.text}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="hmf_merchant_status_text" label="河马付商户状态">
      </el-table-column>
			<el-table-column header-align="center" align="center" prop="reject_reason" label="说明">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="bind_time" label="绑定时间">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="activate_time" label="激活时间">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="reach_time" label="达标时间">
			</el-table-column>
		</el-table>
		<!-- 分页部分 -->
		<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:page-sizes="[20,50,100,200,500,1000,5000,10000]" :page-size="page_size" :total="total"
			layout="total, sizes, prev, pager, next, jumper" style="text-align: right"></el-pagination>

		<!--      机构选择表单部分-->
		<el-dialog v-if="dialogVisible" title="配置表单" :visible.sync="dialogVisible">
			<!--    搜索部分-->
			<el-form :inline="true" :model="dialogForm" class="demo-form-inline">
				<el-form-item label="名称">
					<el-input size="medium" clearable v-model="dialogForm.user_name" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="手机号">
					<el-input size="medium" clearable v-model="dialogForm.mobile_phone" placeholder="请输入"></el-input>
				</el-form-item>
					<el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch1(dialogForm)">搜索</el-button>
					<el-button size="medium"  style="font-size: 12px;" @click="handleSearch2(dialogForm)">重置</el-button>
			</el-form>
			<!--    表格部分-->
			<el-table height="250" :data="dialogData" style="width: 100%"
				:default-sort="{prop: 'date', order: 'descending'}" v-loading="loading1" border
				@row-click="singleElection">
				<el-table-column align="center" width="55">
					<template slot="header">
						<span style="cursor:pointer" @click="cancelClick">取消</span>
					</template>
					<template slot-scope="scope">
						<el-radio class="radio" v-model="templateSelection" :label="scope.row.id">
						{{ " " }}
						</el-radio>
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="id" label="ID" sortable>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="user_name" label="代理商名称">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="mobile_phone" label="代理商手机号">
				</el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<el-pagination background @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
				:page-sizes="[20,50,100,200,500,1000,5000,10000]" :page-size="page_size1" :total="dialogTotal"
				layout="total, sizes, prev, pager, next, jumper" style="text-align: right"></el-pagination>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelDialog">取 消</el-button>
				<el-button type="primary" @click="submitForm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		export_json_to_excel
	} from "@/excel/Export2Excel";
		import prints from '@/components/print.vue'
	export default {
		name: "userInformationOne",
		components:{
			prints
		},
		data() {
			return {
				// 主页面部分
				loading: true, //列表loadding
				page_size: 20, //条数
				total: 0, //总数
				tableData: [], //表格数据
				enquiryForm: {
					organiza_id: '', //代理商ID
					merchant_name: "", //真实姓名
					merchant_code: "", //用户名称
					page_size: 20,
					mobile_phone: "", //手机号码
					page: 1,
					organiza: "", //代理商名称
					opera_center: '',
					opera_center_id: '',
					agent: '',
					agent_id: '',
					top_agent: '',
					top_agent_id: '',
					pos_type:'', //终端类型 
				},
				userid: '', //修改推广码当前行user_id

				// 表单部分
				loading1: true, //列表loadding
				page_size1: 20, //表单条数
				dialogTotal: 0, //表单总数
				dialogData: [], //表单数据
				dialogVisible: false, //表单页面显示
				dialogCodeVisible: false, //邀请码表单页面显示
				dialogForm: { //表单搜索数据
					page_size: 20,
					mobile_phone: "", //手机号码
					page: 1,
					user_name: "", //用户名称
				},
				//   当前选择的行的id
				templateSelection: "",
				//   当前选择的行的数据
				checkList: [],

				tableTdList: [],
				tableThList: [],
				choiceState: 0,
				//打印
				tableTh:null,
				tableTd:null,
			}
		},
		created() {
			this.getData(this.enquiryForm)
			this.tableTh = ['ID', '盟友名称', '盟友手机号', '商户来源','平台商户号', '商户编号',  '商户名称', '商户状态','河马付审核状态', '说明', '更新时间','绑定时间','激活时间','达标时间'];
			this.tableTd = ['id', 'user_name', 'mobile_phone', 'merchant_from_text', 'platform_merchant_code',
				'merchant_code', 'merchant_name', 'merchant_status_text', 'hmf_merchant_status_text','reject_reason','modify_time','bind_time','activate_time','reach_time'];
			this.$nextTick(()=>{
				this.$refs.prints.prints();
			})
		},
		methods: {
			//打印
			printEvent(){
				this.tableData.forEach(item => { //实名状态转换文本
					item.merchant_status_text = item.merchant_status.text;
					item.merchant_from_text = item.merchant_from;
				});
				this.$nextTick(()=>{
					this.$refs.prints.prints();
					this.$refs.prints.print();
				})
			},
			handleDefaultTime() { //默认获取三十天
				let date = this.$moment().endOf('day').format('x');
				this.enquiryForm.create_end_time = this.$moment(Number(date)).format("YYYY-MM-DD HH:mm:ss");
				this.enquiryForm.create_start_time = this.$moment(Number(date) - 3600 * 1000 * 24 * 31 + 1).format("YYYY-MM-DD HH:mm:ss");
				this.enquiryForm.create_time = [this.enquiryForm.create_start_time, this.enquiryForm.create_end_time];

				this.enquiryForm.modify_end_time = this.$moment(Number(date)).format("YYYY-MM-DD HH:mm:ss");
				this.enquiryForm.modify_start_time = this.$moment(Number(date) - 3600 * 1000 * 24 * 31 + 1).format("YYYY-MM-DD HH:mm:ss");
				this.enquiryForm.modify_time = [this.enquiryForm.modify_start_time, this.enquiryForm.modify_end_time];
			},
			pickerChange(DateArr) { //时间选择器
				this.enquiryForm.create_start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
				this.enquiryForm.create_end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
			},
			pickerChange2(DateArr) { //时间选择器
				this.enquiryForm.modify_start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
				this.enquiryForm.modify_end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
			},
			printDemo() {

			},
			// 主页面部分
			//搜索
			handleSearch(searchForm) {
				searchForm.page = 1;
				this.getData(searchForm);
			},
			//重置
			Reset(searchForm) {
				searchForm.page = 1;
				searchForm.organiza_id = '';
				searchForm.organiza = '';
				searchForm.merchant_code = '';
				searchForm.merchant_name="";
				searchForm.mobile_phone = '';
				searchForm.opera_center = '';
				searchForm.opera_center_id = '';
				searchForm.agent = '';
				searchForm.agent_id = '';
				searchForm.top_agent = '';
				searchForm.top_agent_id = '';
				searchForm.org_type = "";
				searchForm.create_time = "";
				searchForm.modify_time="";
				searchForm.merchant_status="";
				searchForm.pos_type='';
        		searchForm.hmf_merchant_status='';
				this.enquiryForm.create_end_time = '';
				this.enquiryForm.create_start_time = "";
				this.enquiryForm.modify_end_time = '';
				this.enquiryForm.modify_start_time = "";
				this.getData(searchForm);
			},
			//分页
			handleCurrentChange(page) { //当前选中页
				this.enquiryForm.page = page;
				this.getData(this.enquiryForm);
			},
			handleSizeChange(limit) { //条数
				this.enquiryForm.page_size = limit;
				this.enquiryForm.page = 1;
				this.getData(this.enquiryForm);
			},
			//获取数据
			getData(params) { //初始化数据
				this.loading = true;
				this.$api.post("/api/merchant/merchantList?page=" + params.page, params, res => {
					if (res.status == 200) {
						let tableData = res.data;
						this.total = tableData.total; //总数
						this.tableData = tableData.list;
					} else {
						this.$message.error(res.msg);
					}
					//渲染结束后取消加载
					this.loading = false;
				})
			},
			// 导出
			exportData() {
		// 		let th = ['ID', '盟友名称', '盟友手机号', '商户来源','平台商户号', '商户编号',  '商户名称', '商户状态','河马付审核状态', '说明', '更新时间'];
		// 		let excelData = ['id', 'user_name', 'mobile_phone', 'merchant_from_text', 'platform_merchant_code',
        //   'merchant_code', 'merchant_name', 'merchant_status_text', 'hmf_merchant_status_text','reject_reason','modify_time'];
		// 		this.tableData.forEach(item => { //实名状态转换文本
		// 			item.merchant_status_text = item.merchant_status.text;
		// 			item.merchant_from_text = item.merchant_from;
		// 		});
		// 		let data = this.formatJson(excelData, this.tableData);
		// 		let defaultTitle = '导出文件';
		// 		export_json_to_excel(th, data, defaultTitle)

				let th = ['ID', '代理商名称', '代理商手机号', '商户来源', '商户号', '终端号', '商户名称', '注册时间', '绑定时间', '商户状态','激活时间','达标时间'];
				let excelData = ['id', 'user_name', 'mobile_phone', 'merchant_from_text', 'merchant_code', 'device_code',
					'merchant_name', 'register_time', 'bind_time', 'merchant_status_text','activate_time','reach_time'];
				this.tableData.forEach(item => { //实名状态转换文本
					item.merchant_status_text = item.merchant_status.text;
					item.merchant_from_text = '杉峰pro平台';

				});
				let data = this.formatJson(excelData, this.tableData);
				let defaultTitle = '导出文件';
				export_json_to_excel(th, data, defaultTitle)
			},
			formatJson(filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => v[j]))
			},
			// 表单部分
			//表单分页
			handleCurrentChange1(page) { //当前选中页
				this.dialogForm.page = page;
				this.getDialogData(this.dialogForm, this.choiceState);
			},
			handleSizeChange1(limit) { //表单条数
				this.dialogForm.page_size = limit;
				this.dialogForm.page = 1;
				this.getDialogData(this.dialogForm, this.choiceState);
			},
			//表单搜索
			handleSearch1(dialogForm) {
				dialogForm.page = 1;
				this.getDialogData(dialogForm, this.choiceState);
			},
			//表单重置
			handleSearch2(dialogForm) {
				dialogForm.page = 1;
				dialogForm.mobile_phone = '';
				dialogForm.user_name = '';
				this.getDialogData(dialogForm, this.choiceState);
			},
			// 机构选择页面显示（表单显示）
			mechanismSearch(can) {
				this.dialogVisible = true;
				this.getDialogData(this.dialogForm, can);
			},
			//表单获取数据
			getDialogData(params, can) { //初始化数据
				this.choiceState = can;
				let url = '';
				if (can == 1) {
					url = "/api/agent/getUserOrganiza?page=" + params.page
				} else if (can == 2) {
					url = "/api/agent/getUserOperaCenter?page=" + params.page
				} else if (can == 3) {
					url = "/api/agent/getUserAgent?page=" + params.page
				} else if (can == 4) {
					url = "/api/agent/getUserAgent?page=" + params.page
				}
				this.loading1 = true;
				this.$api.post(url, params, res => {
					if (res.status == 200) {
						let dialogData = res.data;
						this.dialogTotal = dialogData.total; //总数
						this.dialogData = dialogData.list;
					} else {
						this.$message.error(res.msg);
					}
					//渲染结束后取消加载
					this.loading1 = false;
				})
			},
			//获取每行
			singleElection(row) {
				this.templateSelection = row.id;
				this.checkList = row;
				// this.checkList = this.dialogData.filter((item) => item.id === row.id)
			},
			//取消
			cancelClick() {
				this.checkList = [];
				this.templateSelection = '';
			},
			// 表单确定
			submitForm() {
				if (this.choiceState == 1) {
					this.enquiryForm.organiza = this.checkList.user_name;
					this.enquiryForm.organiza_id = this.checkList.id;
				} else if (this.choiceState == 2) {
					this.enquiryForm.opera_center = this.checkList.user_name;
					this.enquiryForm.opera_center_id = this.checkList.id;
				} else if (this.choiceState == 3) {
					this.enquiryForm.agent = this.checkList.user_name;
					this.enquiryForm.agent_id = this.checkList.id;
				} else if (this.choiceState == 4) {
					this.enquiryForm.top_agent = this.checkList.user_name;
					this.enquiryForm.top_agent_id = this.checkList.id;
				}
				this.handleSearch2(this.dialogForm);
				this.cancelClick();
				this.dialogVisible = false;
				this.getData(this.enquiryForm);
			},
			//表单取消
			cancelDialog() {
				this.handleSearch2(this.dialogForm);
				this.cancelClick();
				this.dialogVisible = false;

			}
		}
	}
</script>

<style scoped>
	/deep/ .el-form-item__content .el-input-group {
		vertical-align: middle !important;
	}

	.code {
		cursor: pointer;
	}
  /deep/ .el-date-editor--datetimerange{
    height: 36px;
    width: 510px;
  }
	.code:hover {
		color: blue;
		text-decoration: underline;
	}
</style>
